import en from "./en";
import ru from "./ru";
import tj from "./tj";

const translations = {
  ru: { translation: ru },
  en: { translation: en },
  tj: { translation: tj },
};

export default translations;
